/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const CurrentEntryPathSegment = styled.span({
  fontWeight: token('font.weight.semibold'),
});

export const LinkedPathSegment = styled.span({
  '& a, & a:hover, & a:focus': {
    color: token('color.text'),
    cursor: 'pointer',
  },
});
